"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.NodeDefMemberEvaluator = void 0;
var member_1 = require("../../../expression/javascript/node/member");
var isNodeDef = function (obj) { return 'uuid' in obj; };
var NodeDefMemberEvaluator = (function (_super) {
    __extends(NodeDefMemberEvaluator, _super);
    function NodeDefMemberEvaluator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeDefMemberEvaluator.prototype.evaluate = function (expressionNode) {
        var object = expressionNode.object, property = expressionNode.property, computed = expressionNode.computed;
        var objectEval = this.evaluator.evaluateNode(object, this.context);
        if (objectEval === null) {
            return null;
        }
        if (computed) {
            return objectEval;
        }
        var propertyNodeDefContext = isNodeDef(objectEval) ? objectEval : this.context.nodeDefContext;
        return this.evaluator.evaluateNode(property, __assign(__assign({}, this.context), { object: objectEval, nodeDefContext: propertyNodeDefContext, selfReferenceAllowed: true }));
    };
    return NodeDefMemberEvaluator;
}(member_1.MemberEvaluator));
exports.NodeDefMemberEvaluator = NodeDefMemberEvaluator;
//# sourceMappingURL=member.js.map